<template>
  <div ref="parent">

    <v-card
      ref="child"
      class="ma-2"
      v-resize="onResize"
      v-scroll="onScroll"
      outlined
      :style="{position: position, top: 0}"
      :width="dynamic_width"
    >

      <v-card-title v-html="'Sumar'"/>

      <v-card-text v-if="getPriceTotal() > 0">

        <v-row no-gutters>
          <v-col cols="12">
            <span class="subtitle-1">
              Rezervare pentru {{getIntervalInDays(availability.check_in, availability.check_out)}} nopti.
            </span>
          </v-col>
          <v-col cols="4" class="font-weight-bold">
            Check-In:
          </v-col>
          <v-col cols="8" class="text-right subtitle-2">
            {{ availability.check_in }}
          </v-col>
          <v-col cols="4" class="font-weight-bold">
            Check-Out:
          </v-col>
          <v-col cols="8" class="text-right subtitle-2">
            {{ availability.check_out }}
          </v-col>
        </v-row>

        <v-divider class="my-3"/>

        <v-row no-gutters>
          <v-col cols="12">
            <span class="subtitle-1">Inventar</span>
            <div v-for="(room, room_index) in availability.rooms" :key="'reservation_room_' + room_index">
              <div v-for="(rate, rate_index) in room.prices" :key="'reservation_rate_' + rate_index">
                <v-row v-if="rate.quantity && rate.quantity > 0" no-gutters align="center">

                  <v-col cols="9" class="text-left text-truncate font-weight-bold">
                    {{rate.quantity}}<small>x</small> {{room.name}}
                  </v-col>

                  <v-col cols="3" class="text-right text-truncate text-capitalize">
                    <im-price
                      :price="rate.price * rate.quantity"
                      :currency="rate.currency"
                      :font-size="14"
                    />
                  </v-col>

                  <v-col cols="12" class="mt-n2 text-left text-truncate text-capitalize caption">
                    {{rate.name}}
                  </v-col>

                </v-row>
              </div>
            </div>
          </v-col>
        </v-row>

        <v-divider class="my-3"/>

        <v-row no-gutters align="center">
          <v-col cols="6">
            <div class="title text-left">Total</div>
          </v-col>
          <v-col>
            <div class="text-right">
              <im-price :font-size="20" :price="getPriceTotal()" :currency="getPriceCurrency()"/>
            </div>
          </v-col>
        </v-row>

      </v-card-text>

      <v-card-text v-else>
        Momentan nu ai adăugat nici o cameră.
      </v-card-text>

      <v-divider/>

      <v-card-actions>
        <v-btn class="primary" block large depressed @click="emitReservation()" :disabled="getPriceTotal() <= 0">Rezervă</v-btn>
      </v-card-actions>

    </v-card>

  </div>
</template>

<script>

  import IMPrice from "../utils/IMPrice";

  export default {

    components: {
      'im-price': IMPrice
    },

    props: {
      availability: {
        type: Object,
        default: () => null
      }
    },

    data: () => ({
      position: 'static',
      dynamic_width: 0,
      dynamic_scroll: 0
    }),

    methods: {

      getIntervalInDays(check_in, check_out) {
        let date1 = this.$moment(check_in);
        let date2 = this.$moment(check_out);

        return date2.diff(date1, 'days');
      },

      getPriceTotal() {
        let total_price = 0;
        this.availability.rooms.forEach(room => {
          room.prices.forEach(rate => {
            if (rate.quantity > 0) {
              total_price += rate.price * rate.quantity;
            }
          });
        });

        return total_price;
      },

      getPriceCurrency() {
        return this.availability.currency;
      },

      emitReservation: function () {
        this.$emit('book');
      },

      onResize: function () {
        this.dynamic_width = this.$refs['parent'].clientWidth - 16;
      },

      onScroll: function (e) {
        this.dynamic_scroll = e.target.scrollingElement.scrollTop;
        if (this.dynamic_scroll > 160 && this.$vuetify.breakpoint.mdAndUp)
          this.position = 'fixed';
        else
          this.position = 'static';
      }

    }

  }
</script>
